/** Files a support ticket from the browser.
 *
 * The route needs a verified caller, so this sends the signed-in user's
 * access token. It reads the persisted token directly rather than through
 * auth-js: getSession() refreshes an expired copy, and in a native shell
 * that reuses a refresh token the shell has already rotated, revoking the
 * family for both sides. An expired or missing token means no request (the
 * route would 401 anyway). The global fetch wrapper skips 401 recovery for
 * this route, so a rejected report can never sign the user out either.
 */

import { API_BASE } from '../utils/supabase/client';
import { peekStoredSession } from '../platform/auth/sessionBootstrapPolicy';

export const SUPPORT_TICKET_ENDPOINT = `${API_BASE}/support-tickets`;

export async function postSupportTicket(payload: Record<string, unknown>): Promise<Response | null> {
  const peek = peekStoredSession();
  // Not isStoredSessionLive: its 90s margin answers "would auth-js refresh",
  // which is irrelevant here, and the server accepts the token until it expires.
  if (!peek || (peek.expiresAt !== null && peek.expiresAt * 1000 <= Date.now())) return null;

  return fetch(SUPPORT_TICKET_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${peek.accessToken}`,
    },
    body: JSON.stringify(payload),
  });
}
